var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container wx"},[_c('van-loading',{staticClass:"wxinfo",attrs:{"type":"spinner","color":"#fff"}},[_vm._v("微信授权中...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }